<section>
  <header>
    <h1 mat-dialog-title class="has-icon"> <i class="DupliKit-KyloeIcon"></i>{{dialogData.mergingEntity | titlecase}} Merge</h1>
    <i class="material-icons close-dialog" (click)="onCancelClick()" title="Close">close</i>
  </header>
  <div mat-dialog-content>
      <ng-container [ngSwitch]="dialogData.mergingEntity">
          <app-candidate-duplicate-details *ngSwitchCase="'candidate'"
                                          [(masterDuplicatesData)]="dialogData"></app-candidate-duplicate-details>
          <app-contact-duplicate-details *ngSwitchCase="'contact'"
                                          [(masterDuplicatesData)]="dialogData"></app-contact-duplicate-details>
          <app-company-duplicate-details *ngSwitchCase="'company'"
                                          [(masterDuplicatesData)]="dialogData"></app-company-duplicate-details>
      </ng-container>
  </div>
</section>
